'use client';

/**
 * E2E Health Panel Connected - Context-aware wrapper for E2EHealthPanel
 *
 * This component connects to SecureAuthContext and SocketContext to provide
 * real-time auth and socket status to the E2E health panel.
 *
 * Place this component inside the dashboard layout where both contexts are available.
 */

import { E2EHealthPanel, useIsE2EEnabled } from './E2EHealthPanel';
import { useSecureAuthContext } from '@/core/auth/services';
import { useSocket } from '@/core/providers/SocketProvider';

/**
 * Connected E2E Health Panel
 *
 * Automatically pulls auth and socket status from their respective contexts.
 * Only renders if E2E mode is enabled.
 */
export function E2EHealthPanelConnected() {
  const isE2EEnabled = useIsE2EEnabled();

  // Early return if E2E mode is not enabled
  if (!isE2EEnabled) {
    return null;
  }

  return <E2EHealthPanelConnectedInner />;
}

/**
 * Inner component that actually uses the hooks
 * Separated to avoid hook calls when E2E is disabled
 */
function E2EHealthPanelConnectedInner() {
  // Get auth status from SecureAuthContext
  const { isAuthenticated } = useSecureAuthContext();

  // Get socket status from SocketContext
  const { connected: socketConnected } = useSocket();

  return (
    <E2EHealthPanel
      isAuthenticated={isAuthenticated}
      socketConnected={socketConnected}
    />
  );
}

export default E2EHealthPanelConnected;
